import { attr } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';
import { service } from '@ember/service';
import Fragment from 'ember-data-model-fragments/fragment';

export const maxReferenceIdLength = 50;

const Validations = buildValidations({
  value: [
    validator('length', {
      max: maxReferenceIdLength,
      message: computed(function () {
        return this.get('model.intl').t('errors.channelCustomFields.referenceId.tooLong');
      }),
    }),
    validator('inline', {
      validate(value, _options, model) {
        if (value && !value.match(/^[a-z0-9]+$/i)) {
          return model.intl.t('errors.channelCustomFields.referenceId.invalidFormat');
        } else {
          return true;
        }
      },
    }),
  ],
});

const ExtendedFragment = Fragment.extend(Validations);

export default class ChannelCustomFieldsReferenceId extends ExtendedFragment {
  @service intl;

  @attr('string', { defaultValue: 'referenceId' }) name;
  @attr('string', { defaultValue: null }) value;
}
